import { select, take, put } from 'redux-saga/effects';
import {
  NOT_ASKED as SEARCH_SERVICE_NOT_ASKED,
  FAILURE as SEARCH_SERVICE_FAILURE,
} from 'services/search';
import {
  NOT_ASKED as ACTIONS_SERVICE_NOT_ASKED,
  FAILURE as ACTIONS_SERVICE_FAILURE,
  selectError as selectActionsServiceError,
} from 'services/actions';
import {
  NOT_ASKED as RECENT_DEPOSITS_SERVICE_NOT_ASKED,
  FAILURE as RECENT_DEPOSITS_SERVICE_FAILURE,
  selectError as selectRecentDepositsServiceError,
} from 'services/recentDeposits';
import {
  NOT_ASKED as DETAILS_SERVICE_NOT_ASKED,
  FAILURE as DETAILS_SERVICE_FAILURE,
  selectError as selectDetailsServiceError,
} from 'services/details';
import {
  NOT_ASKED as UPDATE_WIRE_SERVICE_NOT_ASKED,
  FAILURE as UPDATE_WIRE_SERVICE_FAILURE,
  selectError as selectUpdateWireServiceError,
} from 'services/updateWire';
import {
  NOT_ASKED as SUSPEND_WIRE_SERVICE_NOT_ASKED,
  FAILURE as SUSPEND_WIRE_SERVICE_FAILURE,
  selectError as selectSuspendWireServiceError,
} from 'services/suspendWire';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';
import { legit, authorization } from 'apex-legit-service';
import { clearAllErrors, createAppError } from './actions';
import messages from './messages';
import { selectSearchServiceError, selectUserHasSufficientPermissions } from './selectors';


// TODO: break this out into separate watchers.
//  Looking at this it seems that breaking things out into error messaging auth might be a sensible way to do it.
export function* appFlow() {
  while (true) {
    // Watch for service actions to be dispatched.
    const action = yield take([
      legit.LEGIT_ERROR,
      legit.LOGIN,
      authorization.SUCCESS,
      SEARCH_SERVICE_FAILURE,
      ACTIONS_SERVICE_FAILURE,
      RECENT_DEPOSITS_SERVICE_FAILURE,
      DETAILS_SERVICE_FAILURE,
      UPDATE_WIRE_SERVICE_FAILURE,
      SUSPEND_WIRE_SERVICE_FAILURE,
    ]);

    // eslint-disable-next-line no-continue
    if (!isObject(action)) continue;

    let error;

    // See if user has sufficient permissions.
    // Even if they log in SUCCESS-fully, we want to display an error message
    // when they aren't sufficiently permissioned to use the app.
    if (action.type === authorization.SUCCESS) {
      const hasSufficientPermissions = yield select(selectUserHasSufficientPermissions);
      if (!hasSufficientPermissions){
        error = messages.insufficientPermissions.defaultMessage;
      }
    }

    if (action.type === legit.LOGIN) {
      // On login attempt, clear any error alerts.
      yield put(clearAllErrors());
    }

    // It's a legit error (these don't have error messages from the backend).
    // This happens where the user enters invalid credentials when trying to log in.
    if (
      action.type === legit.LEGIT_ERROR
      && isString(action.params.message)
      && isEmpty(action.params.missingPermissions)
    ) {
      error = action.params.message;
    }

    if (isObject(action.error)) {
      //try to get the status code
      let statusCode = action.error.status;
      if (!isNumber(statusCode) && isObject(action.error.response)) {
        statusCode = action.error.response.status;
      }

      //did we get an unauthorization error?
      if (isNumber(statusCode) && (statusCode === 401)) {
        //if so, force the user to have to login again
        yield put(legit.showLoginUI(legit.LOGIN_UI_SHOW));

        //clear service errors
        switch (action.type) {
          case DETAILS_SERVICE_FAILURE:
            yield put({ type: DETAILS_SERVICE_NOT_ASKED });
            break;
          case UPDATE_WIRE_SERVICE_FAILURE:
            yield put({ type: UPDATE_WIRE_SERVICE_NOT_ASKED });
            break;
          case SUSPEND_WIRE_SERVICE_FAILURE:
            yield put({ type: SUSPEND_WIRE_SERVICE_NOT_ASKED });
            break;
          case SEARCH_SERVICE_FAILURE:
            yield put({ type: SEARCH_SERVICE_NOT_ASKED });
            break;
          case ACTIONS_SERVICE_FAILURE:
            yield put({ type: ACTIONS_SERVICE_NOT_ASKED });
            break;
          case RECENT_DEPOSITS_SERVICE_FAILURE:
            yield put({ type: RECENT_DEPOSITS_SERVICE_NOT_ASKED });
            break;
          default:
            //ignore
            break;
        }
      } else {
        switch (action.type) {
          case SEARCH_SERVICE_FAILURE:
            error = yield select(selectSearchServiceError);
            break;
          case DETAILS_SERVICE_FAILURE:
            error = yield select(selectDetailsServiceError);
            break;
          case UPDATE_WIRE_SERVICE_FAILURE:
            error = yield select(selectUpdateWireServiceError);
            break;
          case SUSPEND_WIRE_SERVICE_FAILURE:
            error = yield select(selectSuspendWireServiceError);
            break;
          case ACTIONS_SERVICE_FAILURE:
            error = yield select(selectActionsServiceError);
            break;
          case RECENT_DEPOSITS_SERVICE_FAILURE:
            error = yield select(selectRecentDepositsServiceError);
            break;
          default:
            //ignore
            break;
        }
      }
    }

    if (error) {
      yield put(createAppError(action.type, error));
    }
  }
}

export default [appFlow()];



// WEBPACK FOOTER //
// ./src/containers/App/sagas.js